module.exports = __webpack_public_path__ + "img/horizontal_3_7_7042.d5eb83e5.png";